import { render, staticRenderFns } from "./checkCartonInfo.vue?vue&type=template&id=0003911f&scoped=true"
import script from "./checkCartonInfo.vue?vue&type=script&lang=js"
export * from "./checkCartonInfo.vue?vue&type=script&lang=js"
import style0 from "./checkCartonInfo.vue?vue&type=style&index=0&id=0003911f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0003911f",
  null
  
)

export default component.exports